<template>
  <BaseButton v-bind="style"
              v-on="$listeners"
              :disabled="disabled">
    <slot />
  </BaseButton>
</template>

<script>
  import BaseButton from '@base/base-button'
  import { FontStyle } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'ButtonTextSecondary',
    inheritAttrs: false,
    components: {
      BaseButton,
    },
    props: {
      disabled: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        style: {
          backgroundColor: 'none',
          cursor: { '': 'pointer', disabled: 'default' },
          border: 'none',
          borderRadius: 'none',
          borderWidth: 'none',
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.lg,
        },
      };
    },
    created: function () {
      this.style = {
        ...this.style,
        borderWidth: '1px',
        color: {
          '': this.color.action1(),
          disabled: this.color.dark3(),
        },
        ...this.$attrs,
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
